import {ValueObject} from '@s-ui/domain'

export class UserAlertsListValueObject extends ValueObject {
  /**
   * @param {Array<UserAlertEntity>} userAlerts
   */

  getUserAlerts() {
    return this._userAlerts
  }
}
